<template>
  <div>
    <div
      class="room-result-container"
      v-if="groupsResult.length"
      :class="{ 'mt-5 sm:mt-0': groupsResult.length === 1 }"
    >
      <div
        class="mt-2 sm:mt-0 flex bg-white px-4"
        v-if="groupsResult.length > 1"
      >
        <div
          class="flex"
          v-for="(group, index) in groupsResult"
          :key="group.id"
        >
          <div
            class="group-title"
            :data-group-id="group.id"
            :class="{ active: group.id === selectedGroupId }"
            @click="selectedGroupId = group.id"
          >
            Room {{ index + 1 }}
          </div>
        </div>
      </div>

      <div>
        <article
          v-for="(room, index) in roomsForCurrentSelectedGroup"
          :key="room.id"
          class="wrap-room flex flex-col"
        >
          <div class="sm:hidden flex items-center justify-between mb-4">
            <div class="flex flex-col">
              <h4 class="fs-20 font-medium">{{ room.name }}</h4>
            </div>
            <span
              class="discount-tag fs-14 sm:hidden offer--purplePrimary -mr-6"
              v-if="getDiscountForSelectedRoom(room.code)"
            >
              {{ getDiscountForSelectedRoom(room.code) }}% off
            </span>
          </div>
          <div class="room-info">
            <div class="sm:flex sm:gap-3 sm:w-full">
              <div class="w-full wrap-image relative">
                <div @click="handleViewRoom(room)" class="cursor-pointer">
                  <room-image-carousel
                    :images="getHbtRoomImages(room.code)"
                  ></room-image-carousel>
                </div>
              </div>

              <div class="flex flex-col flex-1">
                <div class="lg:hidden md:hidden">
                  <h4 class="fs-20 sm:fs-16 font-medium">
                    {{ room.name }}
                  </h4>
                </div>

                <div
                  v-if="getHbtRoom(room.code).bed_type"
                  class="mt-4 sm:mt-2 flex items-center"
                >
                  <svg width="24" height="24" class="black flex-none">
                    <use xlink:href="/img/sprite.svg#ic_double-bed" />
                  </svg>
                  <span class="ml-2">
                    {{ getHbtRoom(room.code).bed_type }}
                  </span>
                </div>

                <div
                  v-if="getHbtRoom(room.code).baseOccupancy"
                  class="mt-2 flex items-center"
                  :class="{ 'mt-4 sm:mt-2': !getHbtRoom(room.code).bed_type }"
                >
                  <svg width="24" height="24">
                    <use xlink:href="/img/sprite.svg#ic_people"></use>
                  </svg>
                  <span class="ml-2">
                    {{ getHbtRoom(room.code).baseOccupancy }} people
                  </span>
                </div>

                <div
                  class="text-secondary font-medium cursor-pointer mt-4 sm:mt-2 w-fit-content"
                  @click="handleViewRoom(room)"
                >
                  View room details
                </div>

                <div v-if="room.description" class="fs-12 italic mt-2">
                  {{ room.description }}
                </div>
              </div>
            </div>
            <div class="room-content">
              <room-option :room="room" :group="selectedGroupId" />
            </div>
          </div>
        </article>
      </div>

      <continue-to-reserve
        v-if="groupsResult.length && groupsResult[0].rooms.length"
      ></continue-to-reserve>

      <div class="sm:bg-white">
        <unavailable-room-result @select="handleViewRoom" />
      </div>
    </div>
    <div v-else-if="!unavailability">
      <unavailable-room-result
        @select="handleViewRoom"
        @detail-for-pricing="handleDetailForPricing"
        type="emptySearch"
      />
    </div>
    <empty-result v-else />

    <room-details-modal :room-code="roomCode" @close="roomCode = null" />
  </div>
</template>

<script>
import UnavailableRoomResult from "./UnavailableRoomResult";
import RoomOption from "./RoomOption.vue";
import EmptyResult from "./EmptyResult.vue";
import RoomImageCarousel from "./RoomImageCarousel.vue";
import CurrencyContext from "../../core/CurrencyContext";
import { mapState, mapGetters } from "vuex";
import RoomDetailsModal from "./RoomDetailsModal.vue";

export default {
  components: {
    UnavailableRoomResult,
    RoomOption,
    EmptyResult,
    RoomImageCarousel,
    CurrencyContext,
    RoomDetailsModal,
  },
  data() {
    return {
      roomCode: null,
    };
  },
  computed: {
    ...mapState([
      "groupsResult",
      "roomsFilter",
      "selectedDealIdPerGroup",
      "selectedRooms",
      "unavailability",
      "dates",
    ]),
    ...mapGetters([
      "getDiscountForSelectedRoom",
      "getHbtRoom",
      "getHbtRoomImages",
    ]),
    selectedGroupId: {
      get() {
        return this.$store.state.selectedGroupId;
      },
      set(value) {
        this.$store.commit("setSelectedGroupId", value);
      },
    },
    roomsForCurrentSelectedGroup() {
      return this.groupsResult
        .find((group) => group.id === this.selectedGroupId)
        .rooms.filter((room) => {
          return Boolean(this.getHbtRoom(room.code));
        });
    },
  },
  methods: {
    handleViewRoom(room) {
      this.roomCode = room.code;
    },
    handleDetailForPricing() {
      if (this.dates[0] && this.roomsFilter.length) {
        this.$store.dispatch("loadRooms");
      } else {
        window.scrollToElement($("h2#Rooms"));
        this.$emit("handle-search");
      }
    },
    isLimitedAvailability(room) {
      let selectedDeal = room.deals[0].id;
      const roomTemp = this.selectedRooms.find(
        (_r) => _r.group === this.selectedGroupId && _r.roomCode === room.code
      );

      if (roomTemp) {
        selectedDeal = roomTemp.id;
      }

      const currentDeal = room.deals.find((deal) => deal.id === selectedDeal);
      return currentDeal.info.availability !== "free_sell";
    },
  },
};
</script>

<style scoped>
.wrap-room:first-child {
  border-top: 1px solid #dcdcdc;
}

.wrap-room {
  padding: 2rem 1.5rem 2rem 2rem;
  border: 1px solid #dcdcdc;
  border-top: none;
}

.room-info {
  display: grid;
  grid-template-columns: 300px 1fr;
  column-gap: 32px;
}

.group-title {
  padding: 1.5rem 1rem;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}

.group-title.active {
  border-bottom: 2px solid var(--secondary);
  color: var(--secondary);
}

.discount-tag {
  padding: 3px 6px;
  border-radius: 4px;
}

@media (max-width: 600px) {
  .wrap-image {
    width: 151px;
  }

  .room-result-container {
    background-color: #f6f6f6;
  }
  .wrap-room {
    display: flex;
    flex-direction: column;
    border: unset;
    padding: 24px 16px 20px 16px;
    z-index: 1;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
    background-color: white;
    margin-bottom: 16px;
  }

  .wrap-room:last-child {
    margin-bottom: 0px;
  }

  .room-info {
    display: flex;
    flex-direction: column;
  }

  .wrap-room ::v-deep .VueCarousel,
  .wrap-room ::v-deep .VueCarousel-inner {
    /* height: 100% !important; */
  }

  .wrap-room ::v-deep .VueCarousel-wrapper {
    overflow-x: hidden !important;
  }

  .wrap-room ::v-deep .VueCarousel-slide {
    max-width: unset;
  }
}
</style>
